<template>
    <div>
        <form ref="companyDocFieldUpdate">
            <h5 class="mb-3 text-uppercase bg-light p-2">
                <i class="mdi mdi-office-building mr-1"></i>
                Company Document
            </h5>
            <div class="col-md-6">
                <div class="form-group">
                    <label>GST Number</label>
                    <input id="gstNo" v-model="company.gstNo"
                           type="text" class="form-control"
                           :class="{ 'is-invalid': submitted && $v.company.gstNo.$error }"/>
                </div>
                <div class="form-group">
                    <label>Pan Number</label>
                    <input id="panNo" v-model="company.panNo"
                           type="text" class="form-control"
                           :class="{ 'is-invalid': submitted && $v.company.panNo.$error }"/>
                </div>
                <div class="form-group">
                    <label>ROC Number</label>
                    <input id="roc" v-model="company.rocNo"
                           type="text" class="form-control"
                           :class="{ 'is-invalid': submitted && $v.company.rocNo.$error }"/>
                </div>
            </div>

        </form>
        <div class="col-md-6">
            <div class="form-group">
                <button type="submit" class="btn btn-primary" @click="fieldUpdate" >Submit</button>
            </div>
        </div>
        <h5 class="mb-3 text-uppercase bg-light p-2">
            <i class="mdi mdi-office-building mr-1"></i>
            Company Document Files
        </h5>
        <div class="row">
            <div class="col-md-4">

                <div class="form-group">
                    <img v-bind:src="company.gstFile"
                         alt="GST Image"
                         width="400px"
                         height="400px"
                         class="img-fluid rounded">
                </div>

                <div class="form-group">
                    <vue-dropzone
                            id="gstDropZone"
                            ref="gstDropZone"
                            :options="gstDropZone"
                            @vdropzone-complete="imageUploaded"
                            v-on:vdropzone-sending="gstUploadEvent">
                    </vue-dropzone>
                </div>

                <div class="form-group">
                    <div class="button-list">
                        <button type="button"
                                class="btn btn-success"
                                @click="gstUpload">
                            <span class="btn-label"><i class="mdi mdi-upload"></i>
                            </span>Success
                        </button>

                        <button type="button"
                                class="btn btn-danger"
                                @click="gstRemove">
                        <span class="btn-label"><i class="mdi mdi-close-circle-outline"></i>
                        </span>Remove
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-4">

                <div class="form-group">
                    <img v-bind:src="company.panFile"
                         alt="PAN Image"
                         width="400"
                         height="400"
                         class="img-fluid rounded">
                </div>

                <div class="form-group">
                    <vue-dropzone
                            id="panDropZone"
                            ref="panDropZone"
                            :options="panDropZone"
                            @vdropzone-complete="imageUploaded"
                            v-on:vdropzone-sending="panUploadEvent">
                    </vue-dropzone>
                </div>

                <div class="form-group">
                    <div class="button-list">
                        <button type="button"
                                class="btn btn-success"
                                @click="panUpload">
                            <span class="btn-label"><i class="mdi mdi-upload"></i>
                            </span>Success
                        </button>

                        <button type="button"
                                class="btn btn-danger"
                                @click="panRemove">
                        <span class="btn-label"><i class="mdi mdi-close-circle-outline"></i>
                        </span>Remove
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-4">

                <div class="form-group">
                    <img v-bind:src="company.rocFile"
                         alt="ROC Image"
                         width="400"
                         height="400"
                         class="img-fluid rounded">

                </div>

                <div class="form-group">
                    <vue-dropzone
                            id="rocDropZone"
                            ref="rocDropZone"
                            :options="rocDropZone"
                            @vdropzone-complete="imageUploaded"
                            @vdropzone-sending="rocUploadEvent">
                    </vue-dropzone>
                </div>

                <div class="form-group">
                    <div class="button-list">
                        <button type="button"
                                class="btn btn-success"
                                @click="rocUpload">
                            <span class="btn-label"><i class="mdi mdi-upload"></i>
                            </span>Success
                        </button>

                        <button type="button"
                                class="btn btn-danger"
                                @click="rocRemove">
                        <span class="btn-label"><i class="mdi mdi-close-circle-outline"></i>
                        </span>Remove
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

  import vue2Dropzone from 'vue2-dropzone'
  import { companiesMethods } from '@state/helpers'

  import {
    required,
    minLength,
    maxLength,

  } from 'vuelidate/lib/validators'

  export default {
    components: { vueDropzone: vue2Dropzone },
    props: {
      company: {
        type: Object,
        default: null,
      },
      id: {
        type: Number,
        default: null,
      },
      companyData: {
        type: Function,
        default: null
      },
    },
    data() {
      return {
        submitted: false,
        gstFile: null,
        panFile: null,
        rocFile: null,
        errorKeys: {
          gstNo: ['Invalid GST', 'Enter a valid GST'],
          panNo: ['Invalid PAN', 'Enter a valid PAN'],
          rocNo: ['Invalid ROC', 'Enter a valid ROC'],
        },
        gstDropZone: {
          url: 'https://api.99gift.in/admin/v1/company/updateDoc/'+this.id,
          thumbnailWidth: 150, // px
          thumbnailHeight: 150,
          maxFilesize: 10,
          maxFiles: 1,
          autoProcessQueue: false,
          dictDefaultMessage: 'GST Image',
          headers: { 'X-Token': window.localStorage.getItem('token') },
        },
        panDropZone: {
          url: 'https://api.99gift.in/admin/v1/company/updateDoc/'+this.id,
          thumbnailWidth: 150, // px
          thumbnailHeight: 150,
          maxFilesize: 10,
          maxFiles: 1,
          autoProcessQueue: false,
          dictDefaultMessage: 'PAN Card Image',
          headers: { 'X-Token': window.localStorage.getItem('token') },
        },
        rocDropZone: {
          url: 'https://api.99gift.in/admin/v1/company/updateDoc/'+this.id,
          thumbnailWidth: 150, // px
          thumbnailHeight: 150,
          maxFilesize: 10,
          maxFiles: 1,
          autoProcessQueue: false,
          dictDefaultMessage: 'ROC Image',
          headers: { 'X-Token': window.localStorage.getItem('token') },
        },
      }
    },
    validations: {
      company : {
        gstNo: { required, minLength: minLength(3), maxLength: maxLength(30) },
        panNo: { required, minLength: minLength(3), maxLength: maxLength(30) },
        rocNo: { required, minLength: minLength(3), maxLength: maxLength(30) },
      },
    },
    mounted() {

    },
    methods: {
      ...companiesMethods,

      gstUploadEvent (file, xhr, formData) {
        formData.append('file', 'gst_file');
      },

      panUploadEvent (file, xhr, formData) {
        formData.append('file', 'pan_file');
      },

      rocUploadEvent (file, xhr, formData) {
        formData.append('file', 'roc_file');
      },

      fieldUpdate: async function (event) {

        try{
          this.submitted = true

          this.$v.$touch()

          if (!this.$v.$invalid) {

            const {
              gstNo,
              rocNo,
              panNo,
            } = this.company;

            const { success, message } = await this.updateCompanyField({
              id: this.id,
              gstNo,
              rocNo,
              panNo,
            })

            if(!success) throw Error(message)

            this.$refs.companyDocFieldUpdate.reset()

            this.appToast('Company updated', 'Document field updated successfully!', 'success')

            this.companyData()
          }
          else{

            let isError = false
            Object.keys(this.$v.company.$params).forEach(each=>{
              if(this.$v.company[each].$error){
                if(!isError){
                  isError = true
                  this.appToast(this.errorKeys[each][0], this.errorKeys[each][1], 'danger')
                }
              }
            })

          }
        }
        catch (e){

          this.appToast('Exception', e.message || 'Error while operating!', 'danger')
        }
      },

      gstUpload: function () {
        this.$refs.gstDropZone.setOption('url', 'https://api.99gift.in/admin/v1/company/updateDoc/'+this.id);
        this.$refs.gstDropZone.processQueue()
      },

      gstRemove: function () {
        this.$refs.gstDropZone.removeAllFiles();
      },

      panUpload: function () {
        this.$refs.panDropZone.setOption('url', 'https://api.99gift.in/admin/v1/company/updateDoc/'+this.id);
        this.$refs.panDropZone.processQueue()
      },

      panRemove: function () {

        this.$refs.panDropZone.removeAllFiles();
      },

      rocUpload: function () {
        this.$refs.rocDropZone.setOption('url', 'https://api.99gift.in/admin/v1/company/updateDoc/'+this.id);
        this.$refs.rocDropZone.processQueue()
      },

      rocRemove: function () {

        this.$refs.rocDropZone.removeAllFiles();
      },

      imageUploaded: function () {
        this.companyData()
      }
    },
  }
</script>